import script from "./Admin.vue?vue&type=script&setup=true&lang=ts"
export * from "./Admin.vue?vue&type=script&setup=true&lang=ts"

import "./Admin.vue?vue&type=style&index=0&id=8ed87eba&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ed87eba"]])

export default __exports__